import { Heading, Text, VStack } from '@chakra-ui/react';
import { axiosInstance } from '@partiu/api/axios';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../../../../../../packages/ui/components/atoms/Button';

export function PlansIphone() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { isLoading, isError, isSuccess, error } = useQuery(
    'subscription-mobile-status',
    () =>
      axiosInstance.post('subscription/check-user-subscription/', {
        token,
      }),
    {
      enabled: !!token,
      refetchInterval: 60000,
      retry: 1,
    }
  );
  const data = useMemo(() => {
    if (isLoading || (isError && error?.response?.status === 404))
      return {
        title: 'Aguardando confirmação do pagamento!',
        text: 'Se você já tiver realizado o pagamento, aguarde um instante, pois estamos validando a transação.',
        body: <Button onClick={() => navigate('/perfil')}>Cancelar</Button>,
      };

    if (isSuccess)
      return {
        title: 'Aquisição realizada com sucesso!',
        text: 'Parabéns! Suas obras digitais já estão disponíveis para download.',
        body: <Button onClick={() => navigate('/')}>Ir para a página principal</Button>,
      };

    return {
      title: 'Erro na compra',
      text: 'Houve um erro ao processar sua compra. Por favor, tente novamente mais tarde.',
      body: <Button onClick={() => navigate('/perfil')}>Voltar</Button>,
    };
  }, [isLoading, isError, error, isSuccess, navigate]);

  return (
    <VStack padding="20px 0px" spacing={5}>
      <Heading fontSize={'24px'}>{data.title}</Heading>
      <Text>{data.text}</Text>
      {data.body}
    </VStack>
  );
}
